/* ML-06 · COMPARISON REPORT
   Same measures, same period, separate Google listings — no naive average, and
   « — » where a location is not live yet, never an invented zero. */
import { Button } from '@/ui'
import { useML } from './EtabShell'

export default function ML06Comparer() {
  const c = useML().compare
  return (
    <section data-frame="ML-06" style={{ display: 'grid', gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 16, flexWrap: 'wrap' }}>
        <h2 className="t-section" style={{ flex: 1 }}>Comparer les établissements</h2>
        <span className="t-muted" style={{ fontSize: 12 }}>mêmes mesures · même période</span>
      </div>
      <div className="tablewrap">
        <table className="tbl">
          <thead><tr>{c.columns.map(h => <th key={h}>{h}</th>)}</tr></thead>
          <tbody>
            {c.rows.map(row => (
              <tr key={row[0]}>
                <td><strong>{row[0]}</strong></td>
                {row.slice(1).map((v, i) => <td key={i}>{v}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        {c.actions.map(a => <Button key={a} variant="quiet" size="sm">{a}</Button>)}
      </div>
      <p className="t-body">
        Fiches Google séparées — jamais de moyenne naïve. « — » = pas encore actif, jamais zéro
        inventé. Insight seulement si les données le portent : « Marais a le meilleur taux
        d’utilisation sur 30 jours. »
      </p>
    </section>
  )
}
